import { NavLink } from 'react-router-dom';
import { Calendar, CheckSquare, List } from 'lucide-react';

const navItems = [
  { to: '/', icon: Calendar, label: 'Calendar' },
  { to: '/chores', icon: CheckSquare, label: 'Chores' },
  { to: '/lists', icon: List, label: 'Lists' },
];

interface SidebarNavIconsProps {
  /** Whether to show labels under icons (hidden when collapsed) */
  showLabels?: boolean;
}

/**
 * Horizontal row of navigation icons for the sidebar
 */
export function SidebarNavIcons({ showLabels = true }: SidebarNavIconsProps) {
  return (
    <nav className="sidebar-nav-row">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            `sidebar-nav-icon ${isActive ? 'active' : ''}`
          }
        >
          <item.icon className="w-5 h-5" />
          {showLabels && <span>{item.label}</span>}
        </NavLink>
      ))}
    </nav>
  );
}
